import { Injectable, inject } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { LookupCriteria } from "@tylertech/tyler-api-types";
import { IServiceOrderExpense } from "../interfaces";
@Injectable()
export class ChargeFeeCodeService
{
    private readonly $apiService = inject(ApiService);


    Lookup(pCriteria: LookupCriteria): Promise<IServiceOrderExpense[]>
    {
        return this.$apiService.sendAuth("IExpenseCodeService/LookupServiceOrderExpense", pCriteria);
    }

    LookupServiceOrderExpenseFiltered(pCriteria: any): Promise<IServiceOrderExpense[]>
    {
        return this.$apiService.sendAuth("IExpenseCodeService/LookupServiceOrderExpenseFiltered", pCriteria);
    }
}
